import styled from 'styled-components'
import { capsuleLightGreyColor, capsuleRed, primaryBackgroundColor } from 'styles/styleVariables'

export type BadgeStatus = 'alert' | 'info' | null

export const Badge = ({ status }: { status: BadgeStatus }) => {
  return <BadgeWrapper status={status} data-testid={`badge-${status}`} />
}

const BadgeWrapper = styled.div<{ status: BadgeStatus }>`
  position: absolute;
  right: -0.1rem;
  top: -0.1rem;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background-color: ${({ status }) => (status === 'alert' ? capsuleRed : capsuleLightGreyColor)};
  border: 1.5px solid ${primaryBackgroundColor};
  z-index: 1;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
